<div class="tax-container">
    <header>
        <nav-bar></nav-bar>
        <div class="header-wrapper">
            <div class="banner-wrapper">
                <div class="banner landing">
                    <div class="intro-block">
                        <p class="sub-title">Tax Certification Portal</p>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <main id="main">
        <div class="content-wrapper">
            <div class="content">
                <article class="main">
                    <h1>Error 404: Page Not Found</h1>
                    <p>We're sorry, we cannot find the page or resource you requested.</p>
                </article>
            </div>
        </div>
    </main>
    <footer-bar></footer-bar>
</div>
